function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrowser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 359.133,
    height: 230.11,
    viewBox: "0 0 359.133 230.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3203"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1",
    transform: "translate(.153 .203)",
    style: {
      fill: "#e6e6e6"
    },
    d: "M0 0h358.979v229.906H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2",
    transform: "translate(10.418 29.04)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h338.449v187.469H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9",
    style: {
      fill: "#ed3833"
    },
    d: "M0 0h358.979v15.251H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 10",
    transform: "translate(197 50.001)",
    style: {
      fill: "#e6e6e6"
    },
    d: "M0 0h123.195v118.912H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 12",
    cx: 2.827,
    cy: 2.827,
    r: 2.827,
    transform: "translate(8.506 4.97)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 13",
    cx: 2.827,
    cy: 2.827,
    r: 2.827,
    transform: "translate(19.236 4.97)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 14",
    cx: 2.827,
    cy: 2.827,
    r: 2.827,
    transform: "translate(29.965 4.97)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 13",
    transform: "translate(36.445 49.31)",
    style: {
      fill: "#ed3833"
    },
    d: "M0 0h32.852v32.852H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 14",
    transform: "translate(82.13 49.498)",
    style: {
      fill: "#e6e6e6"
    },
    d: "M0 0h32.852v32.852H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 15",
    transform: "translate(82.26 94.625)",
    style: {
      fill: "#ed3833"
    },
    d: "M0 0h32.852v109.312H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 16",
    transform: "translate(35.549 94.381)",
    style: {
      fill: "#e6e6e6"
    },
    d: "M0 0h32.852v55.928H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17",
    transform: "translate(196.598 187.579)",
    style: {
      fill: "#e6e6e6"
    },
    d: "M0 0h123.195v16.426H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 18",
    transform: "translate(35.549 162.651)",
    style: {
      fill: "#e6e6e6"
    },
    d: "M0 0h32.852v41.042H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 19",
    transform: "translate(128.972 49.723)",
    style: {
      fill: "#e6e6e6"
    },
    d: "M0 0h32.852v100.586H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 20",
    transform: "translate(128.841 162.752)",
    style: {
      fill: "#e6e6e6"
    },
    d: "M0 0h32.852v41.065H0z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3",
    d: "M582.525 649.962a2.94 2.94 0 0 1-2.874 3.558h-21.844a2.94 2.94 0 0 1-2.875-3.558 14.112 14.112 0 0 1 26.764-2.593 13.987 13.987 0 0 1 .829 2.593zm-24.715-10.826a2.926 2.926 0 0 0 1.608-.48 17.015 17.015 0 0 1 18.624 0 2.94 2.94 0 0 0 3.221-4.919 22.9 22.9 0 0 0-25.065 0 2.94 2.94 0 0 0 1.613 5.4z",
    transform: "translate(-309.866 -532.002)",
    style: {
      fill: "#f8153b"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowser);
export default __webpack_public_path__ + "static/media/browser.1ab4bb619c738de59bd65228515bb0d2.svg";
export { ForwardRef as ReactComponent };